import { Icon, IconProps } from "@/base/components/icon/Icon.component";
import IconSvg from "./alert.svg?react";

export const AlertIcon = (props: IconProps) => (
  <Icon component={IconSvg} {...props} />
);
